import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardContent,
  CardHeader,
  Link,
  Icon,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import ArrowForward from "@material-ui/icons/ArrowForward";
import ContainerCard from "../ContainerCard";
import { useHistory } from "react-router-dom";
import LinesEllipsis from "react-lines-ellipsis";
import Slider from "react-slick";
const useStyles = makeStyles((theme) => ({
  description: {
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
    },
  },
  arrowForward: {
    [theme.breakpoints.down("md")]: {
      fontSize: "1.2rem",
    },
  },
  CardContent: {
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(0),
      height: "20vh",
    },
  },
}));

const AboutUs = (props) => {
  const classes = useStyles();
  const history = useHistory();

  const handleNavigate = (link, extenral) => {
    if (extenral) {
      return window.open(link, "_blank");
    }
    history.push(link);
  };

  const settings = {
    // dots: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 3000,

    verticalSwiping: true,
    beforeChange: function (currentSlide, nextSlide) {
      // console.log("before change", currentSlide, nextSlide);
    },
    afterChange: function (currentSlide) {
      // console.log("after change", currentSlide);
    },
  };
  return (
    <ContainerCard
      title={props.title}
      // link={props?.link}
      // linkTitle={props?.linkTitle}
    >
      <List className={classes.CardContent} dense disablePadding>
        <Slider {...settings} className={classes.Slider}>
          {props.data?.map((data, index) => {
            return (
              <div>
                <div className={classes.slideContainer}>
                  <ListItem
                    button
                    dense
                    key={index}
                    onClick={() => handleNavigate(data.link, data.external)}
                  >
                    <ListItemIcon>
                      <ArrowForward className={classes.arrowForward} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body1"
                          className={classes.description}
                        >
                          {data?.title || "description"}
                          {/* <LinesEllipsis
                            text={data?.title || "description"}
                            maxLine="2"
                            ellipsis="..."
                            trimRight
                            basedOn="letters"
                          /> */}
                        </Typography>
                      }
                    />
                  </ListItem>
                </div>
              </div>
            );
          })}
        </Slider>
      </List>
    </ContainerCard>
  );
};
export default AboutUs;
